import { setErrorLogger } from "@fartherfinance/frontend/logger";

function errorLogger(service: string, message: string) {
  console.error(service, message);
}

setErrorLogger(errorLogger);
